<template>
  <div class="line-radio">
    <p class="line-radio-title">{{ title }}：</p>
    <div class="line-radio-options">
      <label
        v-for="option in options"
        :key="option"
        class="line-radio-option"
        :class="{ 'line-radio-option-selected': isSelected(option) }"
      >
        <span class="line-radio-label">{{ option }}</span>
        <input
          v-if="multiple"
          type="checkbox"
          :name="title"
          :value="option"
          :checked="isSelected(option)"
          @change="onCheckboxChange(option)"
        />
        <input
          v-else
          type="radio"
          :name="title"
          :value="option"
          v-model="value"
          @change="onChange"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    initalValue: [String, Array],
    options: {
      type: Array,
      default: () => [],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      value: "",
      checkboxValue: [],
    };
  },

  created() {
    if (this.multiple) {
      this.checkboxValue = this.parseMultipleValue(this.initalValue);
    } else {
      this.value = this.initalValue == "null" ? "" : this.initalValue;
    }
  },

  watch: {
    initalValue(newVal) {
      if (this.multiple) {
        this.checkboxValue = this.parseMultipleValue(newVal);
      } else {
        this.value = newVal == "null" ? "" : newVal;
      }
    },
  },

  methods: {
    parseMultipleValue(val) {
      if (!val) return [];
      return val
        .split(",")
        .filter(Boolean)
        .map((item) => (item === "粉尘螨" ? "户尘螨" : item));
    },
    isSelected(option) {
      if (this.multiple) {
        return this.checkboxValue.includes(option);
      }
      return this.value === option;
    },
    onChange() {
      this.$emit("onInput", this.title, this.value);
    },
    onCheckboxChange(option) {
      const index = this.checkboxValue.indexOf(option);
      if (index > -1) {
        this.checkboxValue.splice(index, 1);
      } else {
        this.checkboxValue.push(option);
      }
      this.$emit("onInput", this.title, this.checkboxValue.join(","));
    },
  },
};
</script>

<style lang="scss" scoped>
.line-radio {
  background-color: white;
  box-sizing: border-box;
  padding-left: rem(20);
  display: flex;
  align-items: center;

  &-title {
    color: black;
    font-size: rem(14);
    white-space: nowrap;
  }

  &-options {
    display: flex;
    align-items: center;
    flex: 1;
    border-bottom: 1px solid black;
  }

  &-option {
    display: flex;
    align-items: center;
    cursor: pointer;

    input[type="checkbox"] {
      margin: 0;
      margin-right: 0;
      cursor: pointer;
      appearance: none;
      width: rem(10);
      height: rem(10);
      border: 1px solid black;
      border-radius: 0;
      display: flex;
      align-items: center;
      justify-content: center;

      &:checked {
        background-color: white;

        &::after {
          content: '✓';
          color: black;
          font-size: rem(12);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    input[type="radio"] {
      margin: 0;
      margin-right: 0;
      cursor: pointer;
      appearance: none; // 移除默认样式
      width: rem(10);
      height: rem(10);
      border: 1px solid black;
      border-radius: 0; // 设置为正方形
      display: flex;
      align-items: center;
      justify-content: center;

      &:checked {
        background-color: white;

        &::after {
          content: '✓';
          color: black;
          font-size: rem(12);
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }

    &-selected {
      .line-radio-label {
        font-weight: 500;
      }
    }
  }

  &-label {
    color: black;
    font-size: rem(14);
    white-space: nowrap;
  }
}
</style>
